import { Base } from "@app/controllers/base";

// Connects to data-controller="store--file-upload"
export default class extends Base {
  static targets = ["input", "dropzone", "preview", "submitBtn", "statusAwaiting", "statusConfirmed"]

  browse() {
    this.inputTarget.click()
  }

  preview(event) {
    const file = event.target.files?.[0]
    if (file) this.showFile(file)
  }

  dragOver(event) {
    event.preventDefault()
    this.dropzoneTarget.classList.add("border-navy", "bg-background")
    this.dropzoneTarget.classList.remove("border-border")
  }

  dragLeave() {
    this.dropzoneTarget.classList.remove("border-navy", "bg-background")
    this.dropzoneTarget.classList.add("border-border")
  }

  drop(event) {
    event.preventDefault()
    this.dragLeave()
    const file = event.dataTransfer.files?.[0]
    if (file) {
      // Sync to input
      const dt = new DataTransfer()
      dt.items.add(file)
      this.inputTarget.files = dt.files
      this.showFile(file)
    }
  }

  showFile(file) {
    const kb = file.size / 1024
    const sizeLabel = kb > 1024
      ? `${(kb / 1024).toFixed(1)} MB`
      : `${Math.round(kb)} KB`

    // Hide dropzone, show preview
    this.dropzoneTarget.classList.add("hidden")
    this.previewTarget.classList.remove("hidden")
    this.previewTarget.innerHTML = `
      <div class="flex items-center gap-3">
        <span class="flex h-11 w-11 flex-shrink-0 items-center justify-center rounded-lg bg-emerald text-white">
          <svg class="h-5 w-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
            <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M4 16l4.586-4.586a2 2 0 012.828 0L16 16m-2-2l1.586-1.586a2 2 0 012.828 0L20 14m-6-6h.01M6 20h12a2 2 0 002-2V6a2 2 0 00-2-2H6a2 2 0 00-2 2v12a2 2 0 002 2z"/>
          </svg>
        </span>
        <div class="min-w-0 flex-1">
          <div class="flex items-center gap-2">
            <svg class="h-4 w-4 text-emerald flex-shrink-0" fill="none" stroke="currentColor" stroke-width="3" viewBox="0 0 24 24">
              <path stroke-linecap="round" stroke-linejoin="round" d="M5 13l4 4L19 7"/>
            </svg>
            <span class="truncate text-sm font-semibold text-navy">${file.name}</span>
          </div>
          <div class="text-xs text-muted-foreground">${sizeLabel}</div>
        </div>
        <button type="button"
                data-action="click->file-upload#remove"
                class="inline-flex items-center gap-1 text-xs font-semibold text-rose hover:underline flex-shrink-0">
          <svg class="h-3 w-3" fill="none" stroke="currentColor" viewBox="0 0 24 24"><path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M6 18L18 6M6 6l12 12"/></svg>
          Remove
        </button>
      </div>
    `

    // Enable submit button
    if (this.hasSubmitBtnTarget) {
      this.submitBtnTarget.disabled = false
      this.submitBtnTarget.className = this.submitBtnTarget.className
        .replace("bg-light text-muted-foreground cursor-not-allowed", "")
        .trim()
      this.submitBtnTarget.classList.add("bg-emerald", "text-white", "hover:opacity-90")
    }
  }

  remove() {
    this.inputTarget.value = ""
    this.previewTarget.classList.add("hidden")
    this.previewTarget.innerHTML = ""
    this.dropzoneTarget.classList.remove("hidden")

    if (this.hasSubmitBtnTarget) {
      this.submitBtnTarget.disabled = true
      this.submitBtnTarget.classList.remove("bg-emerald", "text-white", "hover:opacity-90")
      this.submitBtnTarget.classList.add("bg-light", "text-muted-foreground", "cursor-not-allowed")
    }
  }

  submit(event) {
    event.preventDefault()
    
    // Disable submit button visually
    if (this.hasSubmitBtnTarget) {
      this.submitBtnTarget.innerHTML = `
        <svg class="mr-2 h-4 w-4 inline animate-spin" fill="none" viewBox="0 0 24 24">
          <circle class="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" stroke-width="4"></circle>
          <path class="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"></path>
        </svg>Uploading...
      `
      this.submitBtnTarget.disabled = true
      this.submitBtnTarget.classList.replace("bg-emerald", "bg-emerald/70")
    }

    // Submit form using Turbo
    this.inputTarget.form.requestSubmit()
  }
}
